module.exports = __webpack_public_path__ + "img/invite.6127fd2b.png";